/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-southeast-1",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://sampf6m42e.execute-api.ap-southeast-1.amazonaws.com/qas",
            "region": "ap-southeast-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://tt52w7zt3rgrjh4nvij7dhn7nq.appsync-api.ap-southeast-1.amazonaws.com/graphql",
    "aws_appsync_region": "ap-southeast-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "ap-southeast-1:104171ca-7ef1-4c6b-bdeb-d36b0e88ba1d",
    "aws_cognito_region": "ap-southeast-1",
    "aws_user_pools_id": "ap-southeast-1_zAVw6GGZb",
    "aws_user_pools_web_client_id": "1me00jt8dn5htdsjj9agupnc3m",
    "oauth": {
        "domain": "productlibrary-qas.auth.ap-southeast-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://qas-productlibrary.neo-corporate.com/",
        "redirectSignOut": "https://qas-productlibrary.neo-corporate.com/signout/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_content_delivery_bucket": "productlibrary-20230301091435-hostingbucket-qas",
    "aws_content_delivery_bucket_region": "ap-southeast-1",
    "aws_content_delivery_url": "https://d334reo1vfaqpi.cloudfront.net",
    "aws_user_files_s3_bucket": "productlibrary8ac91bc9c8fd43c98fa647f982192d1f110123-qas",
    "aws_user_files_s3_bucket_region": "ap-southeast-1"
};


export default awsmobile;
